<template>
  <b-modal
    id="LabStatusHistoryModal"
    ref="LabStatusHistoryModal"
    title="ประวัติสถานะแลป"
    size="lg"
    scrollable
    ok-only
    ok-title="ปิด"
    ok-variant="secondary"
  >
    <div v-if="isLoadingStatusHistory" class="text-center py-4">
      <b-spinner variant="primary"></b-spinner>
      <p class="mt-2">กำลังโหลดข้อมูล...</p>
    </div>

    <div v-else-if="getLabStatusHistory.length === 0" class="text-center py-4">
      <p class="text-muted">ไม่มีประวัติสถานะ</p>
    </div>

    <b-table
      v-else
      hover
      small
      head-variant="light"
      :fields="fields"
      :items="getLabStatusHistory"
    >
      <template v-slot:cell(status)="row">
        <LabStatusBadge :status="row.item.status" />
      </template>
      <template v-slot:cell(creationDt)="row">
        {{ formatDateTime(row.item.creationDt) }}
      </template>
      <template v-slot:cell(creationUser)="row">
        {{ getCreationUserName(row.item.creationUser) }}
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LabStatusBadge from "@/components/badge/LabStatusBadge.vue";
import moment from "moment";

export default {
  name: "LabStatusHistory",
  components: {
    LabStatusBadge
  },
  data() {
    return {
      fields: [
        {
          key: "creationDt",
          label: "วันที่/เวลา",
          sortable: true
        },
        {
          key: "status",
          label: "สถานะ"
        },
        {
          key: "creationUser",
          label: "ผู้บันทึก"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getLabStatusHistory: "moduleLab/getLabStatusHistory",
      isLoadingStatusHistory: "moduleLab/isLoadingStatusHistory"
    })
  },
  methods: {
    ...mapActions({
      fetchLabStatusHistory: "moduleLab/fetchLabStatusHistory"
    }),
    show(labId) {
      this.fetchLabStatusHistory({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        labId
      });
      this.$bvModal.show("LabStatusHistoryModal");
    },
    formatDateTime(date) {
      if (!date) return "-";
      return moment(date).locale("th").format("D MMM YY HH:mm");
    },
    getCreationUserName(user) {
      if (!user) return "-";
      return `${user.firstNameTh || ""} ${user.lastNameTh || ""}`.trim() || "-";
    }
  }
};
</script>

<style scoped>
</style>
